
interface GprofileNotFoundProps {
  onBack: () => void;
}

const GprofileNotFound = ({ onBack }: GprofileNotFoundProps) => {
  console.log('❌ No profile data available');
  
  return (
    <div className="min-h-screen bg-carbon flex items-center justify-center">
      <div className="text-center">
        <h2 className="text-xl font-bold text-toxic-green mb-2">Profile not found</h2>
        <button
          onClick={onBack}
          className="text-toxic-green underline"
        >
          Back to Discovery
        </button>
      </div>
    </div>
  );
};

export default GprofileNotFound;
